import _ from 'lodash';
import React, { PropTypes } from 'react';
import Modal from 'react-modal';

export default class LightBox extends React.Component {

	constructor(props) {
		super(props);
		this.state = { width: window.innerWidth, height: window.innerHeight };
	}

	getStylePosition(style) {
		const { autocenter } = this.props;
		const { width, height } = style.content;

		const { modalWidth, modalheight } = { modalWidth: parseFloat(width), modalheight: parseFloat(height) };
		const { height: viewHeight, width: viewWidth } = window.visualViewport;
		
		if (autocenter) {
			return {
				top: (viewHeight - modalheight) / 2 + "px",
				left: (viewWidth - modalWidth) / 2 + "px",
				right: (viewWidth - modalWidth) / 2 + "px",
				bottom: (viewHeight - modalheight) / 2 + "px"
			};
		}

		return {
			top: (this.state.height - modalheight) / 2 + "px",
			left: (this.state.width - modalWidth) / 2 + "px",
			right: (this.state.width - modalWidth) / 2 + "px",
			bottom: (this.state.height - modalheight) / 2 + "px"
		};
	}

	render () {
		const { isOpen, onClose, style, children } = this.props;
		
		const defaultStyle = {
			overlay: {
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: 'rgba(255, 255, 255, 0.75)'
			},
			content: {
				position: 'absolute',
				top: (this.state.height - 420) / 2 + "px",
				left: (this.state.width - 720) / 2 + "px",
				right: (this.state.width - 720) / 2 + "px",
				bottom: (this.state.height - 420) / 2 + "px",
				width: "720px",
				height: "420px",
				border: '1px solid #ccc',
				background: '#fff',
				overflow: 'auto',
				WebkitOverflowScrolling: 'touch',
				borderRadius: '4px',
				outline: 'none',
				padding: '20px',
				paddingBottom: "10px"
			}
		};

		const partialStyle = _.merge(defaultStyle, style);
		const position = this.getStylePosition(partialStyle);

		return (			
			<Modal 
				isOpen={isOpen}
				contentLabel="Detalhes"
				onRequestClose={onClose}
				style={_.merge(partialStyle, { content: position })}>
				{children}
			</Modal>				
		);
	}
}

LightBox.propTypes = {
	children: PropTypes.object.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	style: PropTypes.object,
	autocenter: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/Common/LightBox.js